// Initialize i18n in the client entry graph so translations are ready before
// any route renders — a route-level import alone lets lazy pages (e.g. /auth)
// render raw keys when their chunk arrives before the i18n chunk.
// NOTE: package.json "sideEffects" must keep listing ./src/i18n/index.ts —
// a bare side-effect import here is otherwise tree-shaken out of the
// production entry and every translated label falls back to raw keys.
import i18n from "@/i18n";

import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

export const getRouter = () => {
  // Reference the i18n instance so no bundler can tree-shake its init away.
  void i18n;
  // Ported from the classic App.tsx QueryClient — keep cache behaviour identical.
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 5 * 60 * 1000, // 5 min — avoid unnecessary refetches
        gcTime: 10 * 60 * 1000, // 10 min — keep cache longer
        refetchOnWindowFocus: false, // Don't refetch every tab switch
        retry: 1, // Only 1 retry on failure
        refetchOnReconnect: "always",
      },
    },
  });

  const router = createRouter({
    routeTree,
    context: { queryClient },
    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
  });

  return router;
};
